<template>
  <v-card v-if="tabs.length > 0">
    <Tabs v-model="tabSelection">
      <v-tab class="activeTab" v-for="(device, index) in tabs" :key="getKey(device, index)"
          @click="tabChange(index)">
          {{ typeof device == 'object' ? $t(device.name).toUpperCase() : $t(device).toUpperCase() }}
      </v-tab>
    </Tabs>
  </v-card>
</template>


<script>
  export default {
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      'tabs': {
        default: function() { return [] }
      },
      lvl: Number,
    },
    data() {
      return {
        tabSelection: 0
      }
    },
    methods: {
      tabChange(tab) {
        this.$emit('activeTabChange', {tab, level: this.lvl})
      },
      getKey(device, index) {
        return index
      }
    },
    watch: {
      tabs: {
        immediate: true, 
        handler (val, oldVal) {
          this.tabSelection = 0
        }
      }
    }
  }
</script>

<style scoped>
  .activeTab:hover {
    background-color: var(--v-sixth-base);
  }
</style>
